var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 1.89474V1.26316C9.33333 0.565535 8.73638 0 8 0H4C3.26362 0 2.66667 0.565535 2.66667 1.26316V1.89474H0.666667C0.298477 1.89474 0 2.1775 0 2.52632C0 2.87513 0.298477 3.15789 0.666667 3.15789H1.33333V10.1053C1.33333 11.1517 2.22876 12 3.33333 12H8.66667C9.77124 12 10.6667 11.1517 10.6667 10.1053V3.15789H11.3333C11.7015 3.15789 12 2.87513 12 2.52632C12 2.1775 11.7015 1.89474 11.3333 1.89474H9.33333ZM8 1.26316H4V1.89474H8V1.26316ZM9.33333 3.15789H2.66667V10.1053C2.66667 10.4541 2.96514 10.7368 3.33333 10.7368H8.66667C9.03486 10.7368 9.33333 10.4541 9.33333 10.1053V3.15789Z",
    fill: "#F56C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.42105H5.33333V9.47368H4V4.42105Z",
    fill: "#F56C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 4.42105H8V9.47368H6.66667V4.42105Z",
    fill: "#F56C6C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e1dee463629795eec30642836299672a.svg";
export { ForwardRef as ReactComponent };